import {observable, action, computed, toJS} from 'mobx';
import $ from 'jquery';
import Cookie from 'js-cookie';

import Group from 'domain/model/Group';
import Product from 'domain/model/wa/Product';

import GroupProduct from '../model/GroupProduct';
import ProductGroup from '../model/ProductGroup';

export default class ProductGroupsSettingsContext {
	/** @type {Array<ProductGroup>} */
	@observable product_groups;

	/** @type {Product} */
	product;
	/** @type {Array<Group>} */
	groups;

	backend_url;

	@observable is_saving = false;

	constructor(state) {
		const {
			product_groups,
			product, groups,
			backend_url
		} = state;

		this.product = new Product(product);
		this.groups = groups.map(g => new Group(g));

		this.backend_url = backend_url;

		this._updateProductGroups(product_groups);
	}

	/**
	 * @param group_id
	 * @return {Group}
	 */
	getGroup(group_id) {
		group_id = parseInt(group_id);

		return this.groups.find(g => g.id === group_id);
	}

	/**
	 * @return {Array<Group>}
	 */
	@computed get available_groups() {
		return this.groups.filter(group => !this.product_groups.find(
			product_group => product_group.group_id === group.id
		));
	}

	@computed get available_groups_options() {
		const options = this.available_groups.map(group => ({
			label: group.name,
			value: group.id,
		}));

		options.push({
			label: '- Добавить группу -',
			value: '',
			style: {color: '#aaa'}
		});

		return options;
	}

	@action addNewProductGroup(group_id) {
		group_id = parseInt(group_id);
		const group = this.getGroup(group_id);

		const product_group = new ProductGroup();

		const first_group_product = new GroupProduct();

		first_group_product.product_id = this.product.id;
		first_group_product.product_name = this.product.name;
		first_group_product.is_primary = true;

		product_group.group_id = group_id;
		product_group.group = group;
		product_group.products.push(first_group_product);

		this.product_groups.push(product_group);

		this.product_groups = this.product_groups.sort((g1, g2) => {
			if (g1.group.sort === g2.group.sort) {
				return 0;
			}

			return g1.group.sort < g2.group.sort ? -1 : 1;
		})
	}

	/**
	 * @param {ProductGroup} product_group
	 */
	@action removeProductGroup(product_group) {
		this.product_groups = this.product_groups.filter(pg => pg._key !== product_group._key);
	}

	@action async save() {
		if (this.is_saving) {
			return false;
		}

		this.is_saving = true;
		this.save_success = false;
		this.save_error = false;

		let success;
		try {
			const response = await $.ajax({
				url: '?plugin=productgroup&module=productGroup&action=saveProducts',
				method: 'POST',
				dataType: 'json',
				data: {
					product_id: this.product.id,
					product_groups: JSON.stringify(toJS(this.product_groups)),
					_csrf: Cookie.get('_csrf'),
				}
			});

			success = response && response.data && response.data.success;

			if (success) {
				this.save_success = true;
				this._updateProductGroups(response.data.new_state.product_groups);
			} else {
				this.save_error = true;
			}
		} catch (e) {
			console.warn(e);
			this.save_error = true;
			success = false;
		}

		this.is_saving = false;

		return success;
	}

	@action _updateProductGroups(product_groups) {
		this.product_groups = product_groups.map(product_group => new ProductGroup({
			id: product_group.id,
			group_id: product_group.group.id,
			group: this.getGroup(product_group.group.id),
			products: product_group.products
		}));
	}
}